import { render, staticRenderFns } from "./CustomerSingle.vue?vue&type=template&id=177e1328&scoped=true"
import script from "./CustomerSingle.vue?vue&type=script&lang=ts"
export * from "./CustomerSingle.vue?vue&type=script&lang=ts"
import style0 from "./CustomerSingle.vue?vue&type=style&index=0&id=177e1328&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177e1328",
  null
  
)

export default component.exports